import React from "react";

/*
 * optionalバッヂ
 */
export default function BudgeOptional() {
  return (
    <span className="py-0.5 px-2 ml-2 text-[10px] font-bold leading-[18px] text-white bg-[#999999] rounded md:text-[12px]">
      任意
    </span>
  );
}
